export default __webpack_public_path__ + "static/media/dying.58c618bf.jpg";